import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { RouterLink } from "@angular/router";

import { AffectedSubscriptionType } from "../../../../../apis/networkdashboard/graphql/graphql";
import { CimImpactTypePipe } from "../../../../../helpers/cim-pipe/cim-pipe";
import { isSupportedProductTag } from "../../../../../helpers/subscription/supported-product-tags";
import { ServiceIcon } from "../../../../subscription-detail/service-icon/service-icon";
import { ServiceId } from "../../../../subscription-detail/service-id/service-id";

@Component({
  selector: "affected-subscription",
  templateUrl: "./affected-subscription.html",
  styleUrls: ["./affected-subscription.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, ServiceIcon, ServiceId, CimImpactTypePipe, RouterLink],
})
export class AffectedSubscription {
  protected subscription = input.required<AffectedSubscriptionType>();
  protected productType = computed(() => this.subscription().subscription.product?.type ?? "unknown");
  protected iconType = computed(() => this.productType().toLowerCase());
  protected description = computed(() => this.subscription().subscription.customerDescription);
  protected impact = computed(() => this.subscription().impactType);
  protected subscriptionId = computed(() => this.subscription().subscriptionId);
  protected routerLink = computed(() => ["/subscription", this.subscriptionId()]);
  protected hasDetailPage = computed(() => isSupportedProductTag(this.subscription().subscription.product?.tag));
}
